import workspaceQuery from 'graphql/queries/product/StockAdjustmentReasonWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/StockAdjustmentReasonListQuery.graphql';
import instanceQuery from 'graphql/queries/product/StockAdjustmentReasonQuery.graphql';
import defaultQuery from 'graphql/queries/product/StockAdjustmentReasonDefault.graphql';
import mutationQuery from 'graphql/mutations/product/StockAdjustmentReasonMutation.graphql';
import fragment from 'graphql/fragments/product/StockAdjustmentReasonFragment.graphql';

const StockAdjustmentReason = {
  type: 'StockAdjustmentReason',
  title: 'Stock Adjustment Reasons',
  formTitle: 'Stock Adjustment Reason',
  formUrl: '/Products/StockControl/StockAdjustmentReason/Details/',
  workspaceUrl: '/Products/StockControl/StockAdjustmentReason/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_STOCK_ADJUSTMENT_REASONS',
};

export default StockAdjustmentReason;
